module.exports = __webpack_public_path__ + "650a9b030c09bd1ff6cddfed49ecf69c.pdf";